export const EXPANDED_SIDEBAR_WIDTH = 224; //px
export const CLOSED_SIDEBAR_WIDTH = 89; //px

export const HEADER_BAR_HEIGHT = 74; //px
export const ADD_BUTTON_HEIGHT = 88; //px

export const TABS_HEIGHT = 64; //px

export const FIXED_BOTTOM_BAR_BUTTON_HEIGHT = 54; //px